import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCall from "redux/services/apiCall";
import { CREATE_SUPPLIER } from "redux/services/apiTypes";

const initialState: {
  loading: boolean;
  success: boolean;
  response: any;
  error: unknown | null;
} = {
  loading: false,
  success: false,
  response: null,
  error: null,
};

export const getStaffDetails = createAsyncThunk(
  "details/staff",
  async (
    payload: {
      staffId: number;
      query: string;
    },
    { fulfillWithValue, rejectWithValue }
  ) => {
    const apiData = {
      type: `${CREATE_SUPPLIER}edit-staff/${payload.staffId}/${payload.query}`,
      apiType: "GET",
    };
    try {
      let res = await apiCall(apiData);
      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const staffDetailsSlice = createSlice({
  name: "staffDetails",
  initialState,
  reducers: {
    clearStaffDetails: (state) => {
      state.loading = false;
      state.success = false;
      state.response = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStaffDetails.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getStaffDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.response = action.payload;
      })
      .addCase(getStaffDetails.rejected, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = action.payload;
      });
  },
});

export const { clearStaffDetails } = staffDetailsSlice.actions;

export default staffDetailsSlice.reducer;
